import { Template } from '@components';
import { useLayout } from '@hooks/layout';
import { Box } from '@mui/material';
import { rem } from '@utils';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const Categories: React.FC = () => {
    const navigate = useNavigate();

    const { layout } = useLayout();

    React.useEffect(() => {
        layout.mobile.header.headerSettings({
            title: 'Categorias',
            onBackAction: () => navigate(-1),
        });
    }, []);

    return (
        <Box pb={rem(20)}>
            <Template.Categories origin='headerBottomMenu' />
        </Box>
    );
};

export { Categories };
